import BaseService from '@src/services/BaseService'
import * as storeFile from "@state/store";
import axios from "axios";

class ExportJobService extends BaseService {
    constructor() {
        super('export-jobs')
    }

    getUrl() {
        return `${process.env.VUE_APP_API_ENDPOINT}/${this.filterTenant ? `tenant/${storeFile.default.getters['auth/tenantId']}/` : ''}${this.urlRoute}`
    }

    create(params) {
        return axios.post(`${this.getUrl()}/create`, params, { timeout: 60000 })
    }

    exportStatus(createResponse) {
        return String(
            createResponse?.status
                ?? createResponse?.response?.status
                ?? ''
        )
    }

    exportErrorMessage(createResponse) {
        return createResponse?.data?.message
            ?? createResponse?.response?.data?.message
            ?? createResponse?.message
            ?? ''
    }

    fetchExportJobProgress(payload) {
        return axios.post(`${this.getUrl()}/progress`, payload)
    }
}

export default new ExportJobService()
